import { fetchTopBannerContent } from "./fetchTopBannerContent";
export var getTopBannerContent = function getTopBannerContent(config) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    urlPath = _ref.urlPath;
  return fetchTopBannerContent(config, urlPath);
};